// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2w-2";
export var placeholderIcon = "_2w-3";
export var thumbnailCanvas = "_2w-1";
export var thumbnailWrapper = "_2w-0";